// AddingIntegrationAccount.js
import React from 'react';
import { Box, Typography, List, ListItem } from '@mui/material';
import '../Docs.css';

export default function AddingIntegrationAccount() {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h2" gutterBottom>
        Adding an Integration&nbsp;Account
      </Typography>

      <Typography paragraph>
        Extend PostSheet beyond Google services by connecting any of these providers:
      </Typography>

      <List className="steps-vertical" sx={{ ml: '2rem' }}>
        <ListItem sx={{ ml: '1rem' }}>
          <Typography variant="h4">
            1&nbsp;·&nbsp;<strong>Twilio</strong> — enter&nbsp;<em>Account&nbsp;Name</em>,
            <em>&nbsp;SID</em> and&nbsp;<em>Auth&nbsp;Token</em> to send WhatsApp &amp; SMS.
          </Typography>
          <img src="../../static/docs/AddTwilio.jpg" alt="Add Twilio account" className="step-img" />
        </ListItem>

        <ListItem sx={{ ml: '1rem' }}>
          <Typography variant="h4">
            2&nbsp;·&nbsp;<strong>Airtable</strong> — provide an&nbsp;<em>Account&nbsp;Name</em>{' '}
            and&nbsp;<em>Personal&nbsp;Access&nbsp;Token</em> to pull records.
          </Typography>
          <img src="../../static/docs/AddAirtable.jpg" alt="Add Airtable account" className="step-img" />
        </ListItem>
      </List>
    </Box>
  );
}
